import UpdatePassword from '../../../components/Auth/UpdatePassword/UpdatePassword';

const UpdatePasswordPage = () => {
  return <UpdatePassword />;
};

export default UpdatePasswordPage;
